import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import NewInquiryForm from '../Layouts/NewInquiryForm';
import { showToast } from 'src/utils/showToaster';
import { useAddContactMutation } from 'src/services/ContactServices';


type Props = {
  onClose: () => void;
};

export type NewInquiryFormValues ={
    name :string ,
    mobile :string ,
    email :string,
}

const AddNewInquiryFormWrapper = ({ onClose }: Props) => {
  const [addQuery] = useAddContactMutation()
  // Form Initial Values
  const initialValues: NewInquiryFormValues = {
    name: '',
    mobile: '',
    email:''
  };

  // Validation Schema
  const validationSchema = object().shape({
    name: string(),
    mobile: string(),
    email :string().email() 
  });

  // Handle Submit
  const handleSubmit = (
    values: NewInquiryFormValues,
    { setSubmitting, resetForm }: FormikHelpers<NewInquiryFormValues>
  ) => {
    addQuery(values).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <NewInquiryForm formikProps={formikProps} onClose={onClose} formType='Add' />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddNewInquiryFormWrapper;